import { BehaviorSubject, fromEvent } from 'rxjs'
import { map, startWith } from 'rxjs/operators'

/**
 * Shared reactive mobile-viewport signal — `(max-width: 767px)`.
 *
 * Layout-switching components observe this instead of hand-rolling their own
 * `matchMedia` listener — if the viewport crosses the boundary while the page
 * is open, consumers respond immediately.
 *
 * @example
 * ```ts
 * import { isMobile$ } from './is-mobile'
 * if (isMobile$.value) return // mobile layout
 * ```
 */
const mediaQuery = typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)') : undefined

export const isMobile$ = new BehaviorSubject<boolean>(mediaQuery?.matches ?? false)

if (mediaQuery) {
	fromEvent<MediaQueryListEvent>(mediaQuery, 'change')
		.pipe(
			map(e => e.matches),
			startWith(mediaQuery.matches),
		)
		.subscribe(matches => {
			isMobile$.next(matches)
		})
}
